import styled from "styled-components";

export const Wrapper = styled.div`
	.notranslate.public-DraftEditor-content {
		max-height: 500px !important;
	}
`;
